module.exports = __webpack_public_path__ + "static/media/thumbnail.d8b716f9.jpg";